import { http } from "./index";

const postSupportRequest = (data) => {
  return http.post("photographer/support", data);
};

export { postSupportRequest };
